module.exports = __webpack_public_path__ + "assets/img/index_title.d30d58bf.png";